import { useState, useCallback } from 'react'
import { LineChart, type LineChartProps } from './LineChart'

export interface TimeSeriesChartProps extends LineChartProps {
  enableBrush?: boolean
  timeRange?: [Date, Date]
  onTimeRangeChange?: (range: [Date, Date]) => void
  brushHeight?: number
}

export function TimeSeriesChart({
  data,
  enableBrush = false,
  timeRange,
  onTimeRangeChange,
  brushHeight = 50,
  height: propHeight,
  ...props
}: TimeSeriesChartProps) {
  const [selectedRange, setSelectedRange] = useState<[Date, Date] | null>(timeRange ?? null)

  const filteredData = selectedRange
    ? data.map((series) => ({
        ...series,
        values: series.values.filter((v) => {
          const d = new Date(v.date).getTime()
          return d >= selectedRange[0].getTime() && d <= selectedRange[1].getTime()
        }),
      }))
    : data

  const handleRangeChange = useCallback(
    (range: [Date, Date]) => {
      setSelectedRange(range)
      onTimeRangeChange?.(range)
    },
    [onTimeRangeChange]
  )

  // Keep handleRangeChange available for future brush interaction
  void handleRangeChange

  const mainHeight = propHeight ?? 300

  return (
    <div className="flex flex-col gap-2">
      <LineChart
        data={filteredData}
        height={mainHeight}
        {...props}
      />
      {enableBrush && (
        <div className="px-[50px]">
          <LineChart
            data={data}
            height={brushHeight}
            showGrid={false}
            showDots={false}
            showLegend={false}
            animate={false}
            margin={{ top: 4, right: 20, bottom: 20, left: 0 }}
            className="opacity-50"
          />
          <div className="text-center text-xs text-[var(--muted-foreground)] mt-1">
            Drag to select time range
          </div>
        </div>
      )}
    </div>
  )
}
